export { default as LoopingCarousel } from './looping-carousel/looping-carousel'
export type { SlideTrackingEvents as LoopingCarouselSlideTrackingEvents } from './looping-carousel/looping-carousel'
